import { render, staticRenderFns } from "./CopyStakeStreamRecordPlayerModal.vue?vue&type=template&id=08632958&scoped=true&lang=pug"
import script from "./CopyStakeStreamRecordPlayerModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamRecordPlayerModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamRecordPlayerModal.vue?vue&type=style&index=0&id=08632958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08632958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCardText,VCol,VProgressCircular,VRow})
